import React from 'react';
import ListDropdown from '../../../List/ListDropdown';

export interface IPersonDropdownProps {
  maxResults?: number;
  value?: any;
  defaultValue?: any;
  worksheetId?: any;
  onChange?: (_: any) => void;
  placeholder?: string;
  queryParams?: any;
}

let PersonDropdown: React.FC<IPersonDropdownProps> = ({
  maxResults = 20,
  value = null,
  defaultValue = null,
  worksheetId: availableForTestId,
  onChange,
  placeholder = 'Select person...',
  queryParams,
  ...otherProps
}) => {
  const personOnChange = (evt: any) => {
    evt.data.value = evt.data.value === null ? null : { Id: evt.data.value.value, Name: evt.data.value.label };
    if (onChange) onChange(evt);
  };
  return (
    <ListDropdown
      {...otherProps}
      endpoint="people"
      placeholder={placeholder}
      onChange={personOnChange}
      value={value && (value.Id || value.Name) ? { value: value.Id, label: value.Name } : null}
      queryParams={{ ...queryParams, availableForTestId, limit: maxResults }}
      defaultValue={{ value: defaultValue && defaultValue.Id, label: defaultValue && defaultValue.Name }}
      maxResults={maxResults}
    />
  );
};

export { PersonDropdown };
export default PersonDropdown;
